import { Box } from '@dtx-company/design-system/src/components/Box/Box'
import { CTA } from './CTA'
import { FAQsSlice } from './types'
import { PrismicAccordion } from '@dtx-company/app/shared/prismic/src/components/PrismicAccordion/PrismicAccordion'
import { Typography } from '@dtx-company/design-system/src'
import { styled } from '@mui/material'
import { useComponentOnScreen } from '../../hooks/useComponentOnScreen'
import { useEffect, useRef } from 'react'
import events from '@dtx-company/inter-app/src/event-tracking/events/homepage'

const twoColumnLayout = `
  "title faqs"
  "ctas faqs"
`

const singleColumnLayout = `
  "title"
  "faqs"
  "ctas"
`

/** One off styles for the FAQ accordion in the homepage */
const HomepagePrismicAccordionWrapper = styled(Box)(({ theme }) => ({
  gridArea: 'faqs',
  ['.MuiAccordionDetails-root']: {
    color: theme.builder.space30
  }
}))

export const FAQs = ({ primary, items }: FAQsSlice): JSX.Element => {
  const ref = useRef<HTMLDivElement>(null)
  const componentIsVisible = useComponentOnScreen(ref)
  useEffect(() => {
    if (componentIsVisible) {
      events.Revenue_HomepageV1_ScrolledTo_Section('faqs')
    }
  }, [componentIsVisible])
  const accordionItems = items.map(item => ({ title: item.question, description: item.answer }))

  return (
    <Box
      component="section"
      sx={theme => ({
        display: 'grid',
        gridTemplateAreas: { xs: singleColumnLayout, md: twoColumnLayout },
        gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
        gap: { xs: 10, md: 10, lg: 20 },
        padding: {
          xs: theme.spacing(20, 10),
          md: theme.spacing(20, 10),
          xl: theme.spacing(30, 20)
        },
        backgroundColor: '#F6F3EF'
      })}
      ref={ref}
    >
      <Box sx={{ gridArea: 'title' }}>
        <Typography variant="displayXLarge" component="h2">
          {primary.heading}
        </Typography>
      </Box>
      <Box
        sx={{
          gridArea: 'ctas',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'end',
          gap: '24px'
        }}
      >
        <CTA
          img={primary.cta1_img}
          line1={primary.cta1_line1}
          line2={primary.cta1_line2}
          line2Href={primary.cta1_line2_href}
          trackLinkClick={() => {
            events.Revenue_HomepageV1_Clicked_FAQTalkWithAnExpert(primary?.cta1_line2_href || '')
          }}
        />

        <CTA
          img={primary.cta2_img}
          line1={primary.cta2_line1}
          line2={primary.cta2_line2}
          line2Href={primary.cta2_line2_href}
          trackLinkClick={() => {
            events.Revenue_HomepageV1_Clicked_FAQVisitHelpcenter(primary?.cta1_line2_href || '')
          }}
        />
      </Box>
      <HomepagePrismicAccordionWrapper>
        <PrismicAccordion items={accordionItems} shouldItemsStartExpanded={false} />
      </HomepagePrismicAccordionWrapper>
    </Box>
  )
}
